import { RAW_PRODUCTS } from './products.generated';

const DEFAULT_TEST_PRODUCT_LINK = 'https://www.xiaohongshu.com/goods-detail/688b1cf1ae962f0015813257?t=1788336876402&xsec_token=AB4tRhFhbgFDl2GxbMyhGSUjxGzKsqbeL0xEAEAT2UvaI%3D&xsec_source=pc_arkselfshare';
const TEST_PRODUCT_LINK = import.meta.env.VITE_TEST_PRODUCT_LINK?.trim() || DEFAULT_TEST_PRODUCT_LINK;

export interface ProductItem {
  id: number;
  name: string;
  type: string;
  price: number;
  primary_element: string;
  secondary_element?: string;
  selling_point: string;
  tags: string[];
  link: string;
  specification?: string;
  issueTags?: string[];
  realWorldTags?: string[];
  recommendedFor?: string;
  usage?: string;
  bundleSuggestion?: string;
  imageFiles?: {
    main?: string;
    thumbnail?: string;
    details?: string[];
  };
  image: string;
  thumbnail: string;
  images: string[];
  placeholderImage: string;
}

function createPlaceholderImage(name: string) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="320" height="320" viewBox="0 0 320 320">
      <defs>
        <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#f6efe4" />
          <stop offset="100%" stop-color="#e3c99a" />
        </linearGradient>
      </defs>
      <rect width="320" height="320" rx="32" fill="url(#bg)" />
      <circle cx="160" cy="120" r="54" fill="rgba(255,255,255,0.45)" />
      <rect x="78" y="195" width="164" height="18" rx="9" fill="rgba(91,61,31,0.12)" />
      <text x="160" y="260" text-anchor="middle" font-size="24" fill="#7b5a34" font-family="PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif">${name}</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

function buildProductImagePath(id: number, filename: string) {
  return `/products/${id}/${filename}`;
}

export const ALL_PRODUCTS: ProductItem[] = RAW_PRODUCTS.map((product) => ({
  ...product,
  link: product.link || TEST_PRODUCT_LINK,
  tags: [...product.tags],
  issueTags: product.issueTags ? [...product.issueTags] : [],
  realWorldTags: product.realWorldTags ? [...product.realWorldTags] : [],
  imageFiles: product.imageFiles
    ? {
        main: product.imageFiles.main || '',
        thumbnail: product.imageFiles.thumbnail || '',
        details: product.imageFiles.details ? [...product.imageFiles.details] : [],
      }
    : {
        main: '',
        thumbnail: '',
        details: [],
      },
  image: product.imageFiles?.main ? buildProductImagePath(product.id, product.imageFiles.main) : '',
  thumbnail: product.imageFiles?.thumbnail ? buildProductImagePath(product.id, product.imageFiles.thumbnail) : '',
  images: [
    ...(product.imageFiles?.main ? [buildProductImagePath(product.id, product.imageFiles.main)] : []),
    ...((product.imageFiles?.details || []).map((filename) => buildProductImagePath(product.id, filename))),
  ],
  placeholderImage: createPlaceholderImage(product.name),
}));

export function getProductsByWuxing(xiYongWuXing: string): ProductItem[] {
  const wuxingMap: Record<string, string[]> = {
    木: ['木', '火'],
    火: ['火', '土'],
    土: ['土', '金'],
    金: ['金', '水'],
    水: ['水', '木'],
  };

  const favorableElements = wuxingMap[xiYongWuXing] || [xiYongWuXing];

  const scoredProducts = ALL_PRODUCTS.map((product) => {
    let score = 0;

    if (product.primary_element === xiYongWuXing) {
      score += 10;
    } else if (favorableElements.includes(product.primary_element)) {
      score += 5;
    } else if (product.primary_element === '综合') {
      score += 3;
    }

    if (product.secondary_element) {
      const secondaryElements = product.secondary_element.split(/[、,，]/).map((elem) => elem.trim());
      for (const elem of secondaryElements) {
        if (elem === xiYongWuXing) {
          score += 5;
        } else if (favorableElements.includes(elem)) {
          score += 3;
        }
      }
    }

    return { ...product, score };
  });

  return scoredProducts
    .filter((product) => product.score > 0)
    .sort((a, b) => b.score - a.score)
    .map(({ score, ...product }) => product);
}
